<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-08-14 20:34:16
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-21 15:06:34
-->
<template>
	<div>
		<el-alert type="warning" show-icon v-if="$auth.hasPermi('system:talent:allocation/re-allocation') && showNotice">
			<template #title>
				<div>
					<span class="yx-color-text-primary">
						{{ content }}
					</span>
					<span style="color: #ff7038" @click="showReAllotDialog" class="pointer" v-if="showStatus == 1">立即重新分配></span>
					<span style="color: #ff7038" v-if="showStatus == 2 && taskStatus">数据处理中...</span>
				</div>
			</template>
		</el-alert>
		<el-alert
			title="达人分配数据处理成功"
			type="success"
			show-icon
			v-if="$auth.hasPermi('system:talent:allocation/re-allocation') && !taskStatus && showStatus == 3"
		></el-alert>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {
		content({ anchorCount }) {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: `团队${anchorCount}达人存在多商务跟进，多商务跟进的达人所产生订单将按商品参数链接来识别业绩归属`,
				[dataMap.PLATFORM_KS.value]: `团队${anchorCount}个达人存在多商务跟进，多商务跟进的达人无法识别业绩归属，您可重新分配达人业绩将自动归属`,
				[dataMap.PLATFORM_SP.value]: `团队${anchorCount}达人存在多商务跟进，多商务跟进的达人所产生订单将按商品参数链接来识别业绩归属`,
			};
			return temPF[this.platformId];
		},
	},
	props: {
		showNotice: {
			type: Boolean,
			default: false,
		},
		anchorCount: {
			type: Number,
			default: 0,
		},
		taskStatus: {
			type: Number,
			default: 1,
		},
		showStatus: {
			type: Number,
			default: 0,
		},
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	methods: {
		showReAllotDialog() {
			this.$emit('showReAllotDialog');
		},
	},
};
</script>

<style lang="less" scoped></style>
